import { TypographyV3 } from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';

interface MembershipAccordionHeaderProps {
  readonly headerMsgKey: string;
  readonly dataCy?: string;
}

const MembershipAccordionHeader = ({
  headerMsgKey,
  dataCy,
}: MembershipAccordionHeaderProps) => {
  const t = useTranslations();
  const header = t(headerMsgKey);
  return (
    <TypographyV3
      weight="bold"
      color="light"
      className="text-base lg:text-xl"
      data-cy={dataCy}
    >
      {header}
    </TypographyV3>
  );
};
export default MembershipAccordionHeader;
